import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setPageTitle } from "../../redux/store/themeConfigSlice"

const NotFound = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageTitle("404 - Böyle Bir Sayfa Yok"))
  }, [dispatch])

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300 dark:text-gray-700">404</h1>
        </div>
        <div className="mb-8">
          <h2 className="text-3xl font-semibold text-gray-800 dark:text-white mb-4">
            Böyle Bir Sayfa Yok
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-lg">Aradığınız sayfa bulunamadı</p>
        </div>
        <button
          onClick={() => navigate("/dashboard/statistics")}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
        >
          Ana Sayfaya Git
        </button>
      </div>
    </div>
  )
}

export default NotFound
